export default __webpack_public_path__ + "static/media/artill_clean_icons.414ec5ca.otf";